import React, { createContext, useContext } from 'react';
import useUrlRedirection from '../../hooks/use-url-redirection';

export type UrlRedirectionContextType = {
  isChecking: boolean;
};

export const UrlRedirectionContext = createContext<UrlRedirectionContextType | void>(undefined);

export const useUrlRedirectionContext = (): UrlRedirectionContextType | void => useContext(UrlRedirectionContext);

export const UrlRedirectionProvider = (props: {children: React.ReactNode | React.ReactNodeArray}): JSX.Element => {
  const urlRedirection = useUrlRedirection();

  return (
    <UrlRedirectionContext.Provider value={urlRedirection}>
      {urlRedirection.isChecking ? null : props.children}
    </UrlRedirectionContext.Provider>
  );
};
